// https://github.com/biati-digital/glightbox
import 'glightbox/dist/css/glightbox.css';
import GLightbox from 'glightbox';


//standard lightbox
const lightbox = GLightbox();

//search box header
$(document).ready(function() {

    const searchbox = GLightbox({
        touchNavigation: false,
        touchFollowAxis: false,
        keyboardNavigation: false,
        selector: ".searchboxlink",
        zoomable: false,
        draggable: false,
        height: 'auto'
    });
    searchbox.on('open', () => {
        $('input[type="search"]').select();
        $('.button--close').click(function() {
            searchbox.close();
        })
    });

    const teambox = GLightbox({
        touchNavigation: false,
        touchFollowAxis: false,
        keyboardNavigation: false,
        selector: ".teamboxlink",
        zoomable: false,
        draggable: false,
        height: 'auto',
        skin: 'teambox'
    });
    teambox.on('open', () => {
        $('.button--close--teambox').click(function() {
            teambox.close();
        })
    });

});
